import Address from './Address';

export default class Office {
    id: number;
    name: string;
    address: Address;

    constructor() {
        this.address = new Address();
    }
}



// WEBPACK FOOTER //
// ./src/models/Office.ts